/**
 * ImportInstructions component displays usage instructions for the import form.
 *
 * @returns {React.ReactElement} Import instructions
 */
export default function ImportInstructions() {
  return (
    <div className="import-instructions">
      <h2 className="import-instructions__title">Importuj fiszki</h2>
      <p className="import-instructions__text">
        Wklej tekst w formacie <code>Pytanie::Odpowiedź</code>, każda fiszka w
        nowej linii. Maksymalnie 40 fiszek na raz.
      </p>
      <div className="import-instructions__example">
        <strong>Przykład:</strong>
        <pre className="import-instructions__code">
          {`Co to jest React?::Biblioteka JavaScript do budowy UI
Kto stworzył React?::Facebook (Meta)
Kiedy powstał React?::2013 rok`}
        </pre>
      </div>
    </div>
  )
}
